/* eslint-disable */
import {
  AutoComplete,
  Button,
  Card, Checkbox, Col, DatePicker,
  Modal,
  Row, Select, Space,
  Typography
} from 'antd';
import dayjs from 'dayjs';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import {
  Controller, FormProvider,
  useFieldArray,
  UseFormReturn
} from 'react-hook-form';
import { useMutation } from 'react-query';

import { PlusOutlined } from '@ant-design/icons';
import { RangePickerProps } from 'antd/es/date-picker';
import Input from 'components/atoms/Input';
import Loading from 'components/atoms/Loading';
import UploadPhoto, { UploadFileType } from 'components/molecules/UploadPhoto';
import { StaffDataType } from 'services/project/types';
import { ocrStaffInfoService } from 'services/staff';
import { contractTypeOptions, NoTaxCode } from 'utils/constants';
import { detectErrorByCode, removeVietnameseDiacriticsAndUppercase } from 'utils/functions';
import Banks from './Banks';

export type Step3Ref = {
  handleFillForm(): void
};

interface Step3Props {
  view?: boolean;
  method: UseFormReturn<RequestStaffForm>
  handleClick: () => void;
  loading?: boolean;
  data?: StaffDataType;
  handleBeforeUseIdCardData?: (idCardNumber: string) => void;
}

const sample = `<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 1">ĐIỀU KHOẢN VỀ THU THẬP V&Agrave; SỬ DỤNG TH&Ocirc;NG TIN C&Aacute; NH&Acirc;N</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:480,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>(&Aacute;p dụng đối với nh&acirc;n sự l&agrave;m việc b&aacute;n thời gian)<br /></span><span data-ccp-props="{}">&nbsp;</span></p>
<p><span>Bằng việc cung cấp th&ocirc;ng tin c&aacute; nh&acirc;n cho C&Ocirc;NG TY TNHH QUẢNG C&Aacute;O BẰNG PH&Aacute;T (sau đ&acirc;y gọi tắt l&agrave; &ldquo;C&ocirc;ng ty&rdquo;), t&ocirc;i x&aacute;c nhận v&agrave; đồng &yacute; với c&aacute;c nội dung sau:</span><span data-ccp-props="{}">&nbsp;</span></p>
<br />
<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 2">1. </span><span data-ccp-parastyle="heading 2">Mục</span> <span data-ccp-parastyle="heading 2">đ&iacute;ch</span> <span data-ccp-parastyle="heading 2">thu</span> <span data-ccp-parastyle="heading 2">thập</span> <span data-ccp-parastyle="heading 2">th&ocirc;ng</span><span data-ccp-parastyle="heading 2"> tin</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:200,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>T&ocirc;i đồng &yacute; cho C&ocirc;ng ty thu thập, lưu trữ v&agrave; sử dụng c&aacute;c th&ocirc;ng tin c&aacute; nh&acirc;n do t&ocirc;i cung cấp (bao gồm nhưng kh&ocirc;ng giới hạn: Họ t&ecirc;n, số CCCD/CMND, ng&agrave;y th&aacute;ng năm sinh, nơi cư tr&uacute;, số sổ BHXH, th&ocirc;ng tin li&ecirc;n hệ, th&ocirc;ng tin lương v&agrave; c&aacute;c th&ocirc;ng tin kh&aacute;c c&oacute; li&ecirc;n quan) cho c&aacute;c mục đ&iacute;ch sau:</span><span data-ccp-props="{}">&nbsp;</span></p>
<ul style="margin-left: 32px;">
<li><span> Quản l&yacute; th&ocirc;ng tin nh&acirc;n sự b&aacute;n thời gian</span></li>
<li><span> K&yacute; kết v&agrave; thực hiện hợp đồng lao động hoặc hợp đồng cộng t&aacute;c</span></li>
<li><span> Thanh to&aacute;n lương, thuế v&agrave; c&aacute;c nghĩa vụ ph&aacute;p l&yacute; c&oacute; li&ecirc;n quan</span></li>
<li><span> Thực hiện đăng k&yacute;, đối so&aacute;t v&agrave; b&aacute;o c&aacute;o với c&aacute;c cơ quan nh&agrave; nước c&oacute; thẩm quyền (bảo hiểm x&atilde; hội, thuế, thanh tra lao động, v.v.)</span></li>
<li><span> Lưu trữ hồ sơ nh&acirc;n sự phục vụ c&ocirc;ng t&aacute;c hậu kiểm v&agrave; b&aacute;o c&aacute;o nội bộ</span></li>
</ul>
<br />
<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 2">2. Phạm vi </span><span data-ccp-parastyle="heading 2">sử</span> <span data-ccp-parastyle="heading 2">dụng</span> <span data-ccp-parastyle="heading 2">th&ocirc;ng</span><span data-ccp-parastyle="heading 2"> tin</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:200,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>Th&ocirc;ng tin c&aacute; nh&acirc;n của t&ocirc;i chỉ được sử dụng nội bộ trong phạm vi C&ocirc;ng ty hoặc chia sẻ với c&aacute;c b&ecirc;n thứ ba c&oacute; li&ecirc;n quan trực tiếp đến việc quản l&yacute; lao động (như đơn vị chi trả lương, cơ quan BHXH, cơ quan thuế&hellip;), v&agrave; kh&ocirc;ng được sử dụng v&agrave;o bất kỳ mục đ&iacute;ch thương mại hoặc c&aacute; nh&acirc;n n&agrave;o kh&aacute;c nếu kh&ocirc;ng c&oacute; sự đồng &yacute; bằng văn bản của t&ocirc;i, trừ trường hợp ph&aacute;p luật c&oacute; quy định kh&aacute;c.</span><span data-ccp-props="{}">&nbsp;</span></p>
<br />
<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 2">3. </span><span data-ccp-parastyle="heading 2">Thời</span> <span data-ccp-parastyle="heading 2">gian</span> <span data-ccp-parastyle="heading 2">lưu</span> <span data-ccp-parastyle="heading 2">trữ</span> <span data-ccp-parastyle="heading 2">th&ocirc;ng</span><span data-ccp-parastyle="heading 2"> tin</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:200,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>Th&ocirc;ng tin c&aacute; nh&acirc;n sẽ được C&ocirc;ng ty lưu giữ trong suốt thời gian t&ocirc;i l&agrave;m việc v&agrave; tối thiểu 05 năm sau khi chấm dứt hợp t&aacute;c, hoặc theo thời hạn lưu trữ bắt buộc theo quy định ph&aacute;p luật hiện h&agrave;nh.</span><span data-ccp-props="{}">&nbsp;</span></p>
<br />
<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 2">4. Quyền </span><span data-ccp-parastyle="heading 2">của</span> <span data-ccp-parastyle="heading 2">t&ocirc;i</span> <span data-ccp-parastyle="heading 2">đối</span> <span data-ccp-parastyle="heading 2">với</span> <span data-ccp-parastyle="heading 2">dữ</span> <span data-ccp-parastyle="heading 2">liệu</span> <span data-ccp-parastyle="heading 2">c&aacute;</span> <span data-ccp-parastyle="heading 2">nh&acirc;n</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:200,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>T&ocirc;i c&oacute; quyền y&ecirc;u cầu:</span><span data-ccp-props="{}">&nbsp;</span></p>
<ul style="margin-left: 32px;">
<li><span> Truy cập, chỉnh sửa hoặc cập nhật th&ocirc;ng tin c&aacute; nh&acirc;n</span></li>
<li><span> R&uacute;t lại sự đồng &yacute; cho ph&eacute;p sử dụng th&ocirc;ng tin (trong phạm vi ph&aacute;p luật cho ph&eacute;p)</span></li>
<li><span> Y&ecirc;u cầu x&oacute;a th&ocirc;ng tin khi kh&ocirc;ng c&ograve;n hợp t&aacute;c, trừ khi ph&aacute;p luật y&ecirc;u cầu lưu trữ</span></li>
</ul>
<p><span>Mọi y&ecirc;u cầu c&oacute; thể được gửi trực tiếp đến bộ phận nh&acirc;n sự của C&ocirc;ng ty để được xử l&yacute; kịp thời v&agrave; minh bạch.</span><span data-ccp-props="{}">&nbsp;</span></p>
<br />
<p><strong><span data-contrast="none"><span data-ccp-parastyle="heading 2">5. Cam </span><span data-ccp-parastyle="heading 2">kết</span> <span data-ccp-parastyle="heading 2">bảo</span> <span data-ccp-parastyle="heading 2">mật</span> <span data-ccp-parastyle="heading 2">của</span><span data-ccp-parastyle="heading 2"> C&ocirc;ng ty</span></span></strong><span data-ccp-props="{&quot;134245418&quot;:true,&quot;134245529&quot;:true,&quot;335559738&quot;:200,&quot;335559739&quot;:0}">&nbsp;</span></p>
<p><span>C&ocirc;ng ty cam kết thực hiện c&aacute;c biện ph&aacute;p kỹ thuật v&agrave; h&agrave;nh ch&iacute;nh hợp l&yacute; để bảo vệ th&ocirc;ng tin c&aacute; nh&acirc;n của t&ocirc;i khỏi mất m&aacute;t, truy cập tr&aacute;i ph&eacute;p, sử dụng sai mục đ&iacute;ch hoặc tiết lộ kh&ocirc;ng ph&ugrave; hợp theo quy định của Nghị định 13/2023/NĐ-CP về Bảo vệ dữ liệu c&aacute; nh&acirc;n.</span><span data-ccp-props="{}">&nbsp;</span></p>
<p><span>Bằng việc tiếp tục cung cấp th&ocirc;ng tin c&aacute; nh&acirc;n, t&ocirc;i x&aacute;c nhận rằng đ&atilde; đọc kỹ, hiểu r&otilde; v&agrave; đồng &yacute; to&agrave;n bộ nội dung của bản điều khoản n&agrave;y.</span><span data-ccp-props="{}">&nbsp;</span></p>
<!-- Comments are visible in the HTML source only -->`;

export type BankAccount = {
  bankOwner: string;
  bankAccount: string;
  isDefault: boolean;
  bankName: OptionType | null;
  bankBranch: OptionType | null;
  city: OptionType | null;
  isActive: boolean;
  bankId?: number;
  isDisabled?: boolean // disable when update
};

export interface RequestStaffForm {
  fullname: string;
  dob?: string;
  taxCode: string | null;
  phoneNumber: string;
  idCardNumber: string;
  idCardIssuedAt?: string;
  idCardIssuedBy?: string;
  permanentAddress: string;
  contractType?: OptionType;
  socialInsuranceNumber: string;
  socialInsuranceJoinDate?: string;
  socialInsuranceImage?: UploadFileType;
  socialInsuranceImagePath?: string;
  idCardFrontImage?: UploadFileType;
  idCardFrontPath?: string;
  idCardBackImage?: UploadFileType;
  idCardBackPath?: string;
  bankAccounts: Array<BankAccount>;
  isAgree: boolean;
}

const eighteenYearsAgo = dayjs().subtract(18, 'year');
const disabledDateUnder18age: RangePickerProps['disabledDate'] = (current) => {
  // Can not select days before today and today
  return current && current.isAfter(eighteenYearsAgo, 'day');
};

const Step3 = forwardRef<Step3Ref, Step3Props>(({ method, view, data, handleClick, loading, handleBeforeUseIdCardData }, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { fields, append, remove } = useFieldArray({
    control: method.control,
    name: 'bankAccounts',
  });

  const handleRemove = async (indexToRemove: number) => {
    await remove(indexToRemove);

    const accounts = method.getValues('bankAccounts');
    const hasDefault = accounts.some((b) => b.isDefault);

    if (!hasDefault && accounts.length > 0) {
      const lastIndex = accounts.length - 1;
      method.setValue(`bankAccounts.${lastIndex}.isDefault`, true);
    }
  };

  const {
    idCardFrontImage: isDirtyFrontIdCard,
    idCardBackImage: isDirtyBackIdCard
  } = method.formState.dirtyFields;

  const isOCR = useRef(false);

  const errorState = method.formState.errors as unknown as {
    [x in keyof RequestStaffForm]: { message: string }
  };

  const frontIdentityPath = isDirtyFrontIdCard ? method.watch('idCardFrontImage')?.pathSubmit || '' : '';
  const backIdentityPath = isDirtyBackIdCard ? method.watch('idCardBackImage')?.pathSubmit || '' : '';

  const { isLoading: isLoadingInfoFromOCR, mutate: mutateInfoFromOCR, data: dataInfoFromOCR } = useMutation(
    ['getInfoFromOCR', frontIdentityPath, backIdentityPath],
    () => ocrStaffInfoService({
      backIdCardPath: backIdentityPath,
      frontIdCardPath: frontIdentityPath,
    }),
    {
      onSuccess: (res) => {
        if (res) {
          handleBeforeUseIdCardData?.(res.data.idCardNumber);
          // const valueForm = method.getValues();
          // const {
          //   idCardAddress, idCardDob, idCardIssuedAt, idCardIssuedBy, idCardName, idCardNumber,
          // } = res.data;
          // method.reset({
          //   ...valueForm,
          //   permanentAddress: idCardAddress || valueForm.permanentAddress,
          //   dob: idCardDob || valueForm.dob,
          //   fullname: idCardName || valueForm.fullname,
          //   idCardIssuedAt: idCardIssuedAt || valueForm.idCardIssuedAt,
          //   idCardIssuedBy: idCardIssuedBy || valueForm.idCardIssuedBy,
          //   idCardNumber,
          // });
        }
      },
      onError: (errors: any) => {
        if (errors && Array.isArray(errors) && errors.length > 0) {
          errors.forEach((item) => {
            method.setError(item.field || 'idCardFrontImage', {
              message: detectErrorByCode(item.code),
              type: 'validate'
            });
          });
        }
      },
      onSettled: () => {
        isOCR.current = false;
      }
    }
  );

  /* Use imperative handler */
  useImperativeHandle(ref, () => ({
    handleFillForm: () => {
      if (dataInfoFromOCR) {
        const valueForm = method.getValues();
        const {
          idCardAddress, idCardDob, idCardIssuedAt, idCardIssuedBy, idCardName, idCardNumber,
        } = dataInfoFromOCR.data;
        method.reset({
          ...valueForm,
          permanentAddress: idCardAddress || valueForm.permanentAddress,
          dob: idCardDob || valueForm.dob,
          fullname: idCardName || valueForm.fullname,
          idCardIssuedAt: idCardIssuedAt || valueForm.idCardIssuedAt,
          idCardIssuedBy: idCardIssuedBy || valueForm.idCardIssuedBy,
          idCardNumber,
        });
      }
    }, // expose reset ra ngoài
  }));

  useEffect(() => {
    if (!frontIdentityPath || !backIdentityPath || isOCR.current) return;
    isOCR.current = true;
    mutateInfoFromOCR();
  }, [frontIdentityPath, backIdentityPath]);

  return (
    <div className="p-home__step3">
      <FormProvider {...method}>
        <div className="site-card-border-less-wrapper">
          <Space direction="vertical" size={12} style={{ width: '100%' }}>
            {
              isLoadingInfoFromOCR && (
                <Loading width={50} variant="fullscreen" colorLoading="secondary" />
              )
            }
            {/* <Card
              extra={view && (!!data?.staffData.frontIdCard || !!data?.staffData.backIdCard) ? null : (
                <Button type="primary" disabled={isLoadingInfoFromOCR || !frontIdentityPath || !backIdentityPath} onClick={() => mutateInfoFromOCR()}>
                  <ScanOutlined />
                  OCR
                </Button>
              )}
              className="u-mb-16"
              style={{ width: '100%' }}
            > */}
            <Row gutter={16}>
              <Col xs={24} sm={12} className="u-mb-16">
                <Typography.Text strong>
                  Ảnh CMND/CCCD mặt trước
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="idCardFrontImage"
                  render={({
                    field: { value, onChange }, fieldState: { error }
                  }) => (
                    <>
                      <UploadPhoto
                        idUpload="idCardFrontImage"
                        description="Upload hình ảnh"
                        className="u-mt-8"
                        // title="Mặt trước"
                        handleChooseFile={onChange}
                        handleRemoveFile={() => {
                          onChange(undefined);
                        }}
                        value={value}
                        big
                      />
                      {
                        error?.message && (
                          <Typography.Text type="danger">
                            {error?.message}
                          </Typography.Text>
                        )
                      }
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={12} className="u-mb-16">
                <Typography.Text strong>
                  Ảnh CMND/CCCD mặt sau
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="idCardBackImage"
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <UploadPhoto
                        idUpload="idCardBack"
                        description="Upload hình ảnh"
                        className="u-mt-8"
                        // title="Mặt trước"
                        handleChooseFile={onChange}
                        handleRemoveFile={() => {
                          onChange(undefined);
                        }}
                        value={value}
                        big
                      />
                      {
                        error?.message && (
                          <Typography.Text type="danger">
                            {error?.message}
                          </Typography.Text>
                        )
                      }
                    </>
                  )}
                />
              </Col>
            </Row>
            {/* </Card> */}
            <Row gutter={16}>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Họ và Tên
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="fullname"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Input
                        className="u-mt-8"
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                          method.getValues('bankAccounts').forEach((_, index) => {
                            method.setValue(`bankAccounts.${index}.bankOwner`, removeVietnameseDiacriticsAndUppercase(e.target.value));
                          });
                        }}
                        size="large"
                        disabled={view && !!data?.staffData.fullname}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Ngày sinh
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="dob"
                  control={method.control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <DatePicker
                        className="u-mt-8"
                        size="large"
                        value={field.value ? dayjs(field.value) : undefined}
                        onChange={field.onChange}
                        format="DD/MM/YYYY"
                        style={{ width: '100%' }}
                        disabled={view && !!data?.staffData.dob}
                        defaultPickerValue={eighteenYearsAgo}
                        disabledDate={disabledDateUnder18age}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Mã số thuế
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="taxCode"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <AutoComplete
                        className="u-mt-8"
                        style={{ width: '100%' }}
                        value={value}
                        onChange={onChange}
                        options={[NoTaxCode]}
                        size="large"
                        disabled={view && !!data?.staffData.taxCode}
                      >
                        <Input
                          value={value ?? undefined}
                          onChange={onChange}
                          size="large"
                          disabled={view && !!data?.staffData.taxCode}
                          allowClear
                        />
                      </AutoComplete>

                      {error && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Số CCCD
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="idCardNumber"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Input
                        className="u-mt-8"
                        value={value}
                        onChange={onChange}
                        size="large"
                        type="number"
                        disabled
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Ngày cấp
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="idCardIssuedAt"
                  control={method.control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <DatePicker
                        className="u-mt-8"
                        size="large"
                        value={field.value ? dayjs(field.value) : undefined}
                        onChange={field.onChange}
                        format="DD/MM/YYYY"
                        style={{ width: '100%' }}
                        disabled={view && !!data?.staffData.idCardIssuedAt}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={8} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Nơi cấp
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="idCardIssuedBy"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Input
                        className="u-mt-8"
                        value={value}
                        onChange={onChange}
                        size="large"
                        disabled={view && !!data?.staffData.idCardIssuedBy}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={12} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Số điện thoại
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="phoneNumber"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Input
                        className="u-mt-8"
                        value={value}
                        onChange={onChange}
                        size="large"
                        disabled={view && !!data?.staffData.phoneNumber}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col xs={24} sm={12} className="p-home__step3__col u-mb-8">
                <Typography.Text strong>
                  Hộ  khẩu thường trú
                  {' '}
                </Typography.Text>
                <Typography.Text strong type="danger">
                  *
                </Typography.Text>
                <Controller
                  name="permanentAddress"
                  control={method.control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Input
                        className="u-mt-8"
                        value={value}
                        onChange={onChange}
                        size="large"
                        disabled={view && !!data?.staffData.permanentAddress}
                      />
                      {error?.message && (
                        <Typography.Text type="danger">
                          {error.message}
                        </Typography.Text>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>
            <Card title={<Typography.Title level={4} className="p-home__card-title">Hợp đồng</Typography.Title>} className="u-mt-16">
              <Row gutter={16}>
                <Col span={24} className="u-mt-8">
                  <Typography.Text strong>
                    Loại hợp đồng
                  </Typography.Text>
                  <Controller
                    name="contractType"
                    control={method.control}
                    render={({
                      field: { value },
                      fieldState: { error },
                    }) => (
                      <>
                        <Select
                          value={value}
                          size="large"
                          style={{ width: '100%', marginTop: '8px' }}
                          disabled
                          options={contractTypeOptions}
                        />
                        {error && (
                          <Typography.Text type="danger">
                            {error?.message}
                          </Typography.Text>
                        )}
                      </>
                    )}
                  />
                </Col>
              </Row>
            </Card>
            <Card title={<Typography.Title level={4} className="p-home__card-title">Bảo hiểm xã hội</Typography.Title>} className="u-mt-16">
              <Row gutter={16}>
                <Col xs={12} className="p-home__step3__col u-mb-8">
                  <Typography.Text strong>
                    Số sổ bảo hiểm
                    {' '}
                  </Typography.Text>
                  <Controller
                    name="socialInsuranceNumber"
                    control={method.control}
                    render={({
                      field: { value, onChange },
                      fieldState: { error },
                    }) => (
                      <>
                        <Input
                          className="u-mt-8"
                          value={value}
                          onChange={onChange}
                          size="large"
                          type="text"
                          disabled={view && !!data?.staffData.socialInsuranceNumber}
                        />
                        {error?.message && (
                          <Typography.Text type="danger">
                            {error.message}
                          </Typography.Text>
                        )}
                      </>
                    )}
                  />
                </Col>
                <Col xs={12} className="p-home__step3__col u-mb-8">
                  <Typography.Text strong>
                    Thời gian đóng
                    {' '}
                  </Typography.Text>
                  <Controller
                    name="socialInsuranceJoinDate"
                    control={method.control}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <DatePicker
                          className="u-mt-8"
                          size="large"
                          value={field.value ? dayjs(field.value) : undefined}
                          onChange={field.onChange}
                          format="DD/MM/YYYY"
                          style={{ width: '100%' }}
                          disabled={view && !!data?.staffData.socialInsuranceJoinDate}
                        />
                        {error?.message && (
                          <Typography.Text type="danger">
                            {error.message}
                          </Typography.Text>
                        )}
                      </>
                    )}
                  />
                </Col>
                <Col span={24} className="p-home__step3__col u-mb-8">
                  <Typography.Text strong>
                    Ảnh VSSID
                    {' '}
                  </Typography.Text>
                  <Controller
                    name="socialInsuranceImage"
                    render={({
                      field: { value, onChange }, fieldState: { error }
                    }) => (
                      <>
                        <UploadPhoto
                          idUpload="vssidImg"
                          description="Upload hình ảnh"
                          className="u-mt-8"
                          handleChooseFile={onChange}
                          handleRemoveFile={() => {
                            onChange(undefined);
                          }}
                          value={value}
                        />
                        {error?.message && (
                          <Typography.Text type="danger">
                            {error.message}
                          </Typography.Text>
                        )}
                      </>
                    )}
                  />
                </Col>
              </Row>
            </Card>
            <Card title={<Typography.Title level={4} className="p-home__card-title">Ngân hàng</Typography.Title>} className="u-mt-16 p-home__card-title">
              {
                fields.map((f, index) => (
                  <Banks
                    key={f.id}
                    positionBank={index}
                    method={method}
                    remove={handleRemove}
                    view={view}
                    bankData={data?.bankData}
                  />
                ))
              }
              {errorState.bankAccounts
                && (
                  <Typography.Text type="danger">
                    {errorState.bankAccounts.message}
                  </Typography.Text>
                )}
              {
                view && data?.bankData && data?.bankData?.length > 0 ? null : (
                  <Button
                    className="u-mt-16"
                    style={{ display: 'block', marginLeft: 'auto' }}
                    type="primary"
                    onClick={() => {
                      if (!method.getValues('fullname')) {
                        method.setError('bankAccounts', {
                          type: 'custom',
                          message: 'Vui lòng nhập Họ và Tên'
                        });
                      } else {
                        method.getValues('bankAccounts').forEach((_, index) => {
                          method.setValue(`bankAccounts.${index}.isDefault`, false);
                        });
                        append({
                          bankOwner: removeVietnameseDiacriticsAndUppercase(method.getValues('fullname')),
                          bankAccount: '',
                          isDefault: true,
                          bankName: null,
                          bankBranch: null,
                          city: null,
                          isActive: true
                        });
                      }
                    }}
                    icon={<PlusOutlined />}
                  >
                    <span style={{ display: 'inline-block', marginLeft: '8px' }}>
                      Thêm tài khoản
                    </span>
                  </Button>
                )
              }
            </Card>
          </Space>
        </div>
        <div className="p-home__step3_terms">
          <Controller
            name="isAgree"
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <div className="p-home__step3_terms_wrap">
                <div className="p-home__step3_terms_checkbox">
                  <Checkbox
                    checked={value}
                    className="p-home__step3_terms_radio"
                    onChange={(val) => onChange(val.target.checked)}
                  />
                  <p className="p-home__step3_terms_text">
                    Tôi hiểu và đồng ý rằng hệ thống Payroll System sẽ
                    lưu trữ và xử lý thông tin cá nhân của tôi theo quy định.
                  </p>
                  &nbsp;
                  <p
                    className="p-home__step3_terms_btn"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Điều khoản và điều kiện
                  </p>
                </div>
                {error?.message && (
                  <Typography.Text type="danger">
                    {error.message}
                  </Typography.Text>
                )}
              </div>
            )}
          />
        </div>
        <div className="p-home__step2_btnWrap">
          <Button
            onClick={handleClick}
            className="p-home__step1__btn"
            type="primary"
            loading={loading}
          >
            Gửi thông tin đăng ký
          </Button>
        </div>
      </FormProvider>
      <Modal
        title={(
          <Typography.Title
            level={3}
            style={{ textAlign: 'center' }}
          >
            Điều khoản và điều kiện
          </Typography.Title>
        )}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={1000}
      >
        <div
          className="p-home__step3_terms_modal"
          dangerouslySetInnerHTML={{ __html: sample }}
        />
      </Modal>
    </div >
  );
});

export default Step3;
